import { CtaButton } from '@zappyrent/hundop';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: grid;
  padding: 20px;
  height: 100vh;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr;
  place-items: center;
`;

export const StyledButton = styled(CtaButton)`
  text-transform: uppercase;
  margin-top: 25px;
  border-radius: 5px;
  cursor: pointer;
`;

export const StyledMessage = styled.div`
  font-size: 20px;
  text-align: center;
`;

export const StyledError = styled.div`
  font-size: 20px;
  color: red;
  text-align: center;
`;

export const StyledDivRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px auto;
  justify-content: space-around;
  gap: 10px;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
`;
